var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "rgba(0, 0, 0, 0.38)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 18,
    height: 6,
    fill: "rgba(0, 0, 0, 0.38)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 6,
    height: 6,
    fill: "rgba(0, 0, 0, 0.38)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 18,
    height: 6,
    fill: "rgba(0, 0, 0, 0.38)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 6,
    height: 6,
    fill: "rgba(0, 0, 0, 0.38)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 18,
    height: 6,
    fill: "rgba(0, 0, 0, 0.38)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.0f889876ab5562ae3bebac0e00e3076b.svg";
export { ForwardRef as ReactComponent };